import { createStyles, makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import { confirmable, createConfirmation } from "react-confirm";
import { StyledDialog, StyledDialogContentText, StyledDialogTitle } from '../CustomStyles/CustomDialog';

function AlertDialog(props) {
    const [open, setOpen] = React.useState(true);
    const { title, content, cancelLabel, submitLabel, proceed } = props;

    function handleClose() {
        setOpen(false);
    }

    return (
        <div>
            <StyledDialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <StyledDialogTitle id="alert-dialog-title">{title}</StyledDialogTitle>
                <DialogContent>
                    <StyledDialogContentText id="alert-dialog-description">
                        {content}
                    </StyledDialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" style={{boxShadow: "none", borderRadius: 0, backgroundColor: "#FFFFFF", padding: "6px 10px"}}>
                        {cancelLabel || "Cancel"}
                    </Button>
                    <Button onClick={proceed} variant="contained" style={{boxShadow: "none", borderRadius: 0, backgroundColor: "#2196F3", color: "#FFFFFF", padding: "6px 10px"}}>
                        {submitLabel || "Submit"}
                    </Button>
                </DialogActions>
            </StyledDialog>
        </div>
    );
}
export function confirm(
    title,
    content,
    cancelLabel,
    submitLabel,
    options = {}
) {
    return createConfirmation(confirmable(AlertDialog))({
        title,
        content,
        cancelLabel,
        submitLabel,
        ...options
    });
}